import React from 'react';
import { Navigate } from 'react-router-dom';

const AdminRoute = ({ children }) => {
    const user = JSON.parse(sessionStorage.getItem('user'));

    if (user && (user.role === 'admin' || user.role === 'subadmin')) {
        return children;
    } else {
        return <Navigate to="/login" />;
    }   
};

export default AdminRoute;